import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Header from "../components/Header";

export default function Login() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const redirectTo = loc.state?.from?.pathname;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      const target = redirectTo || (u.role === "admin" ? "/admin" : "/dashboard");
      nav(target);
    } catch { setErr(t("auth.invalid")); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative" data-testid="login-page">
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-cobalt-100 blob animate-blob pointer-events-none" />
      <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-coral-soft/60 blob animate-blob pointer-events-none" style={{ animationDelay: "-5s" }} />
      <Header />
      <main className="relative">
        <div className="max-w-md mx-auto px-5 py-16">
          <div className="card-soft p-8">
            <div className="overline mb-2">{t("common.login")}</div>
            <h1 className="font-display font-bold text-3xl tracking-tight">{t("auth.loginTitle")}</h1>
            <p className="mt-2 text-ink-700">{t("auth.loginSub")}</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <label className="block">
                <span className="text-sm font-semibold">{t("common.email")}</span>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-soft mt-2" data-testid="login-email" />
              </label>
              <label className="block">
                <span className="text-sm font-semibold">{t("common.password")}</span>
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-soft mt-2" data-testid="login-password" />
              </label>
              {err && <div className="text-sm text-destructive bg-red-50 rounded-xl p-3" data-testid="login-error">{err}</div>}
              <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
                {loading ? t("common.loading") : t("common.login")}
              </button>
            </form>
            <div className="mt-6 text-sm text-ink-700 text-center">
              {t("auth.noAccount")} <Link to="/register" className="text-cobalt-600 font-semibold hover:underline">{t("auth.createOne")}</Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
